module.exports = __webpack_public_path__ + "media/images/icons/close-icon-circle-f98e1a0aa58db5cd273e73a16d0042c7.svg";